'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMAIL = exports.EMAIL = 'EMAIL';
var FB_MESSENGER = exports.FB_MESSENGER = 'FB_MESSENGER';
var LIVE_CHAT = exports.LIVE_CHAT = 'LIVE_CHAT';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/ThreadSources.js
// module id = 104
// module chunks = 2 3